/* Gesture policy shared by the local preview and unpublished integration. */
(function (root) {
  'use strict';
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const MAX_FLICK_STEP = 1; // Retained export for existing integrations.
  function gestureVelocity(samples, releasedAt) {
    const end = samples.at(-1);
    if (!end || samples.length < 2 || releasedAt - end.t > 160) return 0;
    // Measure movement, not the stationary interval while a finger lifts.
    // Keep an older anchor when Safari supplies only one recent move event.
    let start = samples[0];
    for (let i = samples.length - 2; i >= 0; i--) {
      start = samples[i];
      if (end.t - start.t >= 55) break;
    }
    return (end.x - start.x) / Math.max(16, end.t - start.t);
  }
  function gestureStep(distance) {
    if (Math.abs(distance) < 18) return 0;
    // Every deliberate swipe advances one design. Speed never adds steps.
    return -Math.sign(distance);
  }
  const api = { clamp, gestureStep, gestureVelocity, MAX_FLICK_STEP };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BullseyeNavigation = api;
})(typeof window === 'undefined' ? globalThis : window);
